import { CollectionEntriesRepository } from '@lib/api/repository/collection-entries';
import { CollectionEntryQuery } from '@lib/types/collection-entries';

export default class CollectionEntriesService {
  constructor(private readonly repository: CollectionEntriesRepository) {}
  start(collectionId: string) {
    return this.repository.start(collectionId);
  }

  find(input: CollectionEntryQuery, signal?: AbortSignal) {
    return this.repository.find(input, signal);
  }
}
